import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { CompanyCarousel } from "./components/CompanyCarousel";
import { Services } from "./components/Services";
import { Process } from "./components/Process";
import { CaseStudies } from "./components/CaseStudies";
import { FeedbackCarousel } from "./components/FeedbackCarousel";
import { VideoFeedbackCarousel } from "./components/VideoFeedbackCarousel";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <CompanyCarousel />
        <Services />
        <VideoFeedbackCarousel />
        <Process />
        {/* <CaseStudies /> */}
        <FeedbackCarousel />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
